import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import api from "../../api";
import { renderQualificationWithSpecialization } from "helpers/common";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import JobDescription from "./JobDescription";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";

const JobDetails = () => {
  const { vacancyId } = useParams();
  const location = useLocation();

  const [job, setJob] = useState(null);
  const [showJD, setShowJD] = useState(false);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/admin/job/fetch-jobdetailsbyid/${vacancyId}`,
        );
        console.log("JobDetails API response:", res.data.allJobs);
        setJob(res.data.allJobs);
      } catch (err) {
        console.error(err);
      }
    };

    fetchJob();
  }, [vacancyId]);

  if (!job) return null;

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <MetaTags><title>Create Department</title></MetaTags> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/job-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Back to Job List
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/department-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-4">
            <Container fluid>
              {/* <Breadcrumbs title="Department" breadcrumbItem="Create Department" /> */}

              <Col lg="12">
                <div className="page-content job-details-page">
                  {/* Back */}

                  {/* Title */}
                  <h2 className="mb-1">{job.title}</h2>

                  {job.franchise?.franchise_name && (
                    <p className="text-muted mb-2" style={{ paddingBottom: '0px'}}>
                      <strong>Dealership:</strong> {job.franchise.franchise_name}
                    </p>
                  )}

                  {job?.franchiseStores?.length > 0 && (
                    <p className="text-muted mb-2">
                      <strong>Locations:</strong>{" "}
                      {job.franchiseStores.map(s => s?.label).join(", ")}
                    </p>
                  )}

                  {/* BASIC DETAILS */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <Detail
                          label="Minimum Experience"
                          value={job.experience}
                        />
                        <Detail
                          label="Relevant Experience"
                          value={job.relevant_experience ? `${job.relevant_experience} years` : ""}
                        />
                        <Detail
                          label="Employment Type"
                          value={job.expected_time}
                        />
                        <Detail
                          label="Candidate Preference"
                          value={
                            job.female_candidates_preferred
                              ? "Female Preferred"
                              : "Open to All"
                          }
                        />
                        <Detail
                          label="Openings"
                          value={job.number_of_openings}
                        />
                        <Detail
                          label="Department"
                          value={
                            job.vacancyDepartments?.length > 0
                              ? job.vacancyDepartments
                                  .map(d => d.label || d.name)
                                  .filter(Boolean)
                                  .join(", ")
                              : "—"
                          }
                        />
                        <Detail
                          label="Annual CTC"
                          value={`₹${job.min_salary?.toLocaleString()} - ₹${job.max_salary?.toLocaleString()}`}
                        />
                        <Detail
                          label="Position Level"
                          value={job.VacancyType?.title}
                        />
                        <Detail
                          label="Qualification"
                          value={renderQualificationWithSpecialization(
                            job?.qualification,
                            job?.specializationMap
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* VIEW JOB DESCRIPTION */}
                  {job.description && (
                    <button
                      className="btn btn-outline-primary mb-4"
                      onClick={() => setShowJD(true)}
                    >
                      View Full Job Description
                    </button>
                  )}

                  {/* SKILLS */}
                  {Array.isArray(job?.vacancySkills) &&
                    job.vacancySkills.length > 0 && (
                      <div className="card mb-4">
                        <div className="card-body">
                          <h5 className="mb-3">Required Skills</h5>
                          <div className="d-flex flex-wrap gap-2">
                            {job.vacancySkills.map(skill => (
                              <span
                                key={skill.id}
                                className="badge bg-light text-dark border"
                              >
                                {skill.name}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                  {/* INTERVIEW ROUNDS */}
                  {Array.isArray(job.roundList) && job.roundList.length > 0 && (
                    <div className="card mb-4">
                      <div className="card-body">
                        <h5 className="mb-3">Interview Rounds</h5>
                        {job.roundList.map((round, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center border-bottom py-2"
                          >
                            <div>
                              <div className="fw-semibold">{round.label} {round?.interviewer?.name && `: ${round.interviewer.name}`}</div>
                              {round.description && (
                                <div className="text-muted small">
                                  {round.description}
                                </div>
                              )}
                            </div>
                            {round.type === 'Test' && (
                              <span className="badge bg-info">
                                Passing Score: {round.score_threshold}%
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ================= REACT JD MODAL ================= */}
             {showJD && (
  <div className="jd-overlay" onClick={() => setShowJD(false)}>
    <div className="jd-container" onClick={e => e.stopPropagation()}>
      <div className="jd-header">
        <h5>Job Description</h5>
        <button onClick={() => setShowJD(false)}>✕</button>
      </div>

      <div className="jd-body">
        <JobDescription description={job.description} />
      </div>
    </div>
  </div>
)}

                </div>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const Detail = ({ label, value }) => (
  <div className="col-md-6 mb-3">
    <div className="text-muted small">{label}</div>
    <div className="fw-500">{value || "—"}</div>
  </div>
);

export default JobDetails;
